import { render, staticRenderFns } from "./favorite.vue?vue&type=template&id=656bf84e&scoped=true&lang=pug"
import script from "./favorite.vue?vue&type=script&lang=js"
export * from "./favorite.vue?vue&type=script&lang=js"
import style0 from "./favorite.vue?vue&type=style&index=0&id=656bf84e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656bf84e",
  null
  
)

export default component.exports